export default from './Map.js';



// WEBPACK FOOTER //
// ./src/components/Map/index.js